<div class="nct-wrap">
  <div class="nct-header">
    <h2>Nota Control (NFS-e) — Teste de Comunicação</h2>
    <p class="nct-subtitulo">
      Consulta a lista de DPS disponíveis, só para confirmar se o backend consegue falar com o
      webservice (certificado, URL e cabeçalho). Ainda não emite nem envia nada.
    </p>
  </div>

  <div class="nct-form">
    <label class="nct-label">
      Página
      <input
        type="number"
        min="1"
        [ngModel]="pagina()"
        (ngModelChange)="pagina.set($event)"
        class="nct-input-pagina"
      />
    </label>
    <button class="nct-btn" (click)="consultar()" [disabled]="carregando()">
      {{ carregando() ? 'Consultando...' : 'Consultar DPS Disponível' }}
    </button>
  </div>

  <div class="nct-erro" *ngIf="erro()">
    <strong>{{ erro() }}</strong>
    <div class="nct-erro-detalhe">{{ erroDetalhe() }}</div>
  </div>

  <div class="nct-resultado" *ngIf="resultado()">
    <div class="nct-resultado-resumo">
      <span><strong>Página:</strong> {{ resultado()?.pagina ?? '—' }}</span>
      <span><strong>DPS encontradas:</strong> {{ resultado()?.dpsDisponiveis?.length ?? 0 }}</span>
      <span><strong>Mensagens:</strong> {{ resultado()?.mensagens?.length ?? 0 }}</span>
    </div>
    <pre class="nct-json">{{ jsonResultado() }}</pre>
  </div>

  <hr class="nct-separador" />

  <div class="nct-header">
    <h2>ABRASF 2.04 — Consultas em Produção</h2>
    <p class="nct-subtitulo">
      Webservice legado por município (o mesmo que o sistema atual já usa para emitir nota).
      Só consultas — nenhuma delas emite, cancela ou altera nada. A estrutura exata de cada
      consulta ainda não foi confirmada oficialmente com a Nota Control para este modelo —
      se algum campo estiver errado, o retorno é só um erro de schema (sem risco).
    </p>
  </div>

  <!-- ConsultarNfseServicoPrestado -->
  <div class="nct-secao">
    <h3>Notas emitidas por período</h3>
    <div class="nct-form">
      <label class="nct-label">
        Data inicial
        <input type="date" [ngModel]="spDataInicial()" (ngModelChange)="spDataInicial.set($event)" />
      </label>
      <label class="nct-label">
        Data final
        <input type="date" [ngModel]="spDataFinal()" (ngModelChange)="spDataFinal.set($event)" />
      </label>
      <label class="nct-label">
        Página
        <input type="number" min="1" class="nct-input-pagina" [ngModel]="spPagina()" (ngModelChange)="spPagina.set($event)" />
      </label>
      <button class="nct-btn" (click)="consultarServicoPrestado()" [disabled]="estadoServicoPrestado.carregando()">
        {{ estadoServicoPrestado.carregando() ? 'Consultando...' : 'Consultar' }}
      </button>
    </div>
    <div class="nct-erro" *ngIf="estadoServicoPrestado.erro()">
      <strong>{{ estadoServicoPrestado.erro() }}</strong>
      <div class="nct-erro-detalhe">{{ estadoServicoPrestado.erroDetalhe() }}</div>
    </div>
    <div class="nct-resultado" *ngIf="estadoServicoPrestado.resultado()">
      <div class="nct-resultado-resumo">
        <span><strong>Mensagens:</strong> {{ estadoServicoPrestado.resultado()?.mensagens?.length ?? 0 }}</span>
      </div>
      <pre class="nct-json">{{ estadoServicoPrestado.resultado()?.respostaXmlBruta }}</pre>
    </div>
  </div>

  <!-- ConsultarNfsePorRps -->
  <div class="nct-secao">
    <h3>Nota específica por RPS</h3>
    <div class="nct-form">
      <label class="nct-label">
        Número
        <input type="text" [ngModel]="rpsNumero()" (ngModelChange)="rpsNumero.set($event)" />
      </label>
      <label class="nct-label">
        Série
        <input type="text" [ngModel]="rpsSerie()" (ngModelChange)="rpsSerie.set($event)" />
      </label>
      <label class="nct-label">
        Tipo
        <input type="text" [ngModel]="rpsTipo()" (ngModelChange)="rpsTipo.set($event)" style="width: 50px" />
      </label>
      <button class="nct-btn" (click)="consultarPorRps()" [disabled]="estadoPorRps.carregando()">
        {{ estadoPorRps.carregando() ? 'Consultando...' : 'Consultar' }}
      </button>
    </div>
    <div class="nct-erro" *ngIf="estadoPorRps.erro()">
      <strong>{{ estadoPorRps.erro() }}</strong>
      <div class="nct-erro-detalhe">{{ estadoPorRps.erroDetalhe() }}</div>
    </div>
    <div class="nct-resultado" *ngIf="estadoPorRps.resultado()">
      <div class="nct-resultado-resumo">
        <span><strong>Mensagens:</strong> {{ estadoPorRps.resultado()?.mensagens?.length ?? 0 }}</span>
      </div>
      <pre class="nct-json">{{ estadoPorRps.resultado()?.respostaXmlBruta }}</pre>
    </div>
  </div>

  <!-- ConsultarNfsePorFaixa -->
  <div class="nct-secao">
    <h3>Notas por faixa de numeração</h3>
    <div class="nct-form">
      <label class="nct-label">
        Nº inicial
        <input type="text" [ngModel]="faixaInicial()" (ngModelChange)="faixaInicial.set($event)" />
      </label>
      <label class="nct-label">
        Nº final
        <input type="text" [ngModel]="faixaFinal()" (ngModelChange)="faixaFinal.set($event)" />
      </label>
      <label class="nct-label">
        Página
        <input type="number" min="1" class="nct-input-pagina" [ngModel]="faixaPagina()" (ngModelChange)="faixaPagina.set($event)" />
      </label>
      <button class="nct-btn" (click)="consultarPorFaixa()" [disabled]="estadoPorFaixa.carregando()">
        {{ estadoPorFaixa.carregando() ? 'Consultando...' : 'Consultar' }}
      </button>
    </div>
    <div class="nct-erro" *ngIf="estadoPorFaixa.erro()">
      <strong>{{ estadoPorFaixa.erro() }}</strong>
      <div class="nct-erro-detalhe">{{ estadoPorFaixa.erroDetalhe() }}</div>
    </div>
    <div class="nct-resultado" *ngIf="estadoPorFaixa.resultado()">
      <div class="nct-resultado-resumo">
        <span><strong>Mensagens:</strong> {{ estadoPorFaixa.resultado()?.mensagens?.length ?? 0 }}</span>
      </div>
      <pre class="nct-json">{{ estadoPorFaixa.resultado()?.respostaXmlBruta }}</pre>
    </div>
  </div>

  <!-- ConsultarUrlNfse -->
  <div class="nct-secao">
    <h3>Link de visualização/impressão (PDF)</h3>
    <div class="nct-form">
      <label class="nct-label">
        Número da nota
        <input type="text" [ngModel]="urlNumeroNfse()" (ngModelChange)="urlNumeroNfse.set($event)" />
      </label>
      <button class="nct-btn" (click)="consultarUrlNfse()" [disabled]="estadoUrlNfse.carregando()">
        {{ estadoUrlNfse.carregando() ? 'Consultando...' : 'Consultar' }}
      </button>
    </div>
    <div class="nct-erro" *ngIf="estadoUrlNfse.erro()">
      <strong>{{ estadoUrlNfse.erro() }}</strong>
      <div class="nct-erro-detalhe">{{ estadoUrlNfse.erroDetalhe() }}</div>
    </div>
    <div class="nct-resultado" *ngIf="estadoUrlNfse.resultado()">
      <div class="nct-resultado-resumo">
        <span><strong>Mensagens:</strong> {{ estadoUrlNfse.resultado()?.mensagens?.length ?? 0 }}</span>
      </div>
      <pre class="nct-json">{{ estadoUrlNfse.resultado()?.respostaXmlBruta }}</pre>
    </div>
  </div>

  <!-- ConsultarDadosCadastrais -->
  <div class="nct-secao">
    <h3>Dados cadastrais do prestador</h3>
    <div class="nct-form">
      <button class="nct-btn" (click)="consultarDadosCadastrais()" [disabled]="estadoDadosCadastrais.carregando()">
        {{ estadoDadosCadastrais.carregando() ? 'Consultando...' : 'Consultar' }}
      </button>
    </div>
    <div class="nct-erro" *ngIf="estadoDadosCadastrais.erro()">
      <strong>{{ estadoDadosCadastrais.erro() }}</strong>
      <div class="nct-erro-detalhe">{{ estadoDadosCadastrais.erroDetalhe() }}</div>
    </div>
    <div class="nct-resultado" *ngIf="estadoDadosCadastrais.resultado()">
      <div class="nct-resultado-resumo">
        <span><strong>Mensagens:</strong> {{ estadoDadosCadastrais.resultado()?.mensagens?.length ?? 0 }}</span>
      </div>
      <pre class="nct-json">{{ estadoDadosCadastrais.resultado()?.respostaXmlBruta }}</pre>
    </div>
  </div>
</div>
